// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
/* eslint-disable */
const awsExportsDev = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://tmnfkenpo-api.dev.kenchare.net/graphql', // 東京海上は修正不要（AppSyncのエンドポイントを固定で申請しているため）
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:ac2bcd14-9549-4f1f-9779-6f380bef3846',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_G4YWj9nsR',
  'aws_user_pools_web_client_id': '4b4pfg2i9seac8opfd2kc16ftf',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'tmnfkenpo-backend-dev-tmnfkenpobac-private5ed30f02-uexjxevcvdcl',
      region: 'ap-northeast-1'
    }
  }
}

const awsExportsStg = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://tmnfkenpo-api.stg.kenchare.net/graphql', // 東京海上は修正不要（AppSyncのエンドポイントを固定で申請しているため）
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:f95f328b-1b8e-493f-a40c-41a0cfc159cc',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_BWEP9XRlA',
  'aws_user_pools_web_client_id': '7a18rijjq9s90g6dlak5vg1drt',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'tmnfkenpo-backend-stg-tmnfkenpobac-private5ed30f02-ysfa24iawe7z',
      region: 'ap-northeast-1'
    }
  }
}

const awsExportsProd = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://tmnfkenpo-api.kenchare.net/graphql', // 東京海上は修正不要（AppSyncのエンドポイントを固定で申請しているため）
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:03386846-6769-47d4-b816-727282e66580',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_SxYddDNKd',
  'aws_user_pools_web_client_id': '3gvmk6ghict9bgsv9b12itva7v',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'tmnfkenpo-backend-prod-tmnfkenpoba-private5ed30f02-ajadplmaosxy',
      region: 'ap-northeast-1'
    }
  }
}

export {
  awsExportsDev,
  awsExportsStg,
  awsExportsProd
}
